import { render, staticRenderFns } from "./cardPrintAdd.vue?vue&type=template&id=0588929c"
import script from "./cardPrintAdd.vue?vue&type=script&lang=js"
export * from "./cardPrintAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports